'use client';

import React from 'react';

interface CategoryPillProps {
  label: string;
  emoji?: string;
  isActive?: boolean;
  onClick?: () => void;
  color?: string;
  bgColor?: string;
}

export default function CategoryPill({ label, emoji, isActive, onClick, color, bgColor }: CategoryPillProps) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-hindi font-semibold whitespace-nowrap transition-all duration-150 btn-press border ${
        isActive
          ? 'shadow-sm'
          : 'border-border bg-card hover:bg-muted text-foreground'
      }`}
      style={
        isActive && color && bgColor
          ? { color, backgroundColor: bgColor, borderColor: color }
          : isActive
          ? { backgroundColor: 'var(--primary)', color: 'var(--primary-foreground)', borderColor: 'var(--primary)' }
          : undefined
      }
    >
      {emoji && <span className="text-sm leading-none">{emoji}</span>}
      {label}
    </button>
  );
}